/* Phase 8B (bugfix) -- Global banner shown at the very top of the shell
 * whenever a client-side "preview as role" overlay is active. Reset button
 * clears the overlay without touching the server session.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { Eye, X } from "lucide-react";
import { useModuleVisibility } from "@/store/moduleVisibility";

export default function PreviewBanner() {
  const { t } = useTranslation();
  const previewRole = useModuleVisibility((s) => s.previewRole);
  const clearPreview = useModuleVisibility((s) => s.clearPreview);
  return (
    <AnimatePresence>
      {previewRole && (
        <motion.div
          initial={{ y: -32, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -32, opacity: 0 }}
          className="fixed top-16 left-0 right-0 z-40 mx-4 lg:mx-8"
          data-testid="preview-banner"
        >
          <div className="rounded-xl border border-sky-500/40 bg-gradient-to-r from-brand-blue/90 to-sky-500/70 backdrop-blur-md px-4 py-2 flex items-center gap-3 shadow-lg">
            <Eye className="h-4 w-4 text-white shrink-0" />
            <div className="text-sm text-white font-medium flex-1">
              {t("modules.previewBanner", { role: t(`modules.role.${previewRole.toLowerCase()}`, previewRole) })}
            </div>
            <button
              onClick={clearPreview}
              className="text-white/90 hover:text-white text-xs font-medium flex items-center gap-1 px-2 py-1 rounded hover:bg-white/10"
              data-testid="preview-banner-reset"
            >
              <X className="h-3 w-3" /> {t("modules.previewReset")}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
